import {Rating} from '@mantine/core';

export const RatingTheme = Rating.extend({
  defaultProps: {
    count: 5,
    fractions: 1,
    size: 'xs',
  }
})